const shader = `
uniform sampler2D colorMap;
uniform float opacity;

varying vec2 vUv;

void main() {
    vec4 color = texture2D( colorMap, vUv );
    float new_alpha = min(color.a, opacity);
    gl_FragColor = vec4(color.rgb,new_alpha);
}
`;

export default shader;